/* istanbul ignore file */
import React, { ReactElement, ReactNode, useState, useEffect } from "react";
import { defaultSettings, SettingsContext, SettingsType } from "./settings-context";

export const SettingsProvider = ({
  children,
  loadingLogo
}: {
  children: ReactNode;
  loadingLogo: any;
}): ReactElement => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [data, setData] = useState<SettingsType | null>(null);

  useEffect(() => {
    const fetchSettings = async (): Promise<void> => {
      try {
        const response = await fetch("/settings.json");
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const jsonData = await response.json();
        setData(jsonData);
      } catch (e) {
        setError(e as Error);
      } finally {
        setLoading(false);
      }
    };

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (async () => {
      await fetchSettings();
    })();
  }, []);

  /* istanbul ignore next */
  if (error) throw error;
  /* istanbul ignore next */
  if (loading || !data) return <></>;

  return (
    <SettingsContext.Provider value={{ ...defaultSettings, ...(data as Partial<SettingsType>) }}>
      {children}
    </SettingsContext.Provider>
  );
};
